// extracted by mini-css-extract-plugin
export default {"navbar_ts":"Header_navbar_ts__R7L7q","active":"Header_active__ucHEW","btn_red":"Header_btn_red__s8+zl","btn_bordered":"Header_btn_bordered__S0fb4"};